import type { MyViewWidget, WidgetFilter, FilterOptions } from "../../../api/myViewController";

export const filterFields: { key: keyof WidgetFilter; options: keyof FilterOptions; title: string }[] = [
	{ key: "brandIds", options: "brands", title: "Brands" },
	{ key: "channelIds", options: "channels", title: "Channels" },
	{ key: "marketerIds", options: "marketers", title: "Vendors" },
	{ key: "usStateIds", options: "states", title: "States" },
	{ key: "branchIds", options: "branches", title: "Branches" },
	{ key: "utilityIds", options: "utilities", title: "Utilities" },
];
export function configuration(widget?: MyViewWidget): Record<string, unknown> {
	try {
		const parsed = JSON.parse(widget?.configJson || "{}");
		return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
	} catch {
		return {};
	}
}
export function getValue(config: Record<string, unknown>, key: string) {
	return config[Object.keys(config).find((k) => k.toLowerCase() === key.toLowerCase()) ?? key];
}
export function initialFilter(widget?: MyViewWidget): WidgetFilter {
	const config = configuration(widget);
	const result: WidgetFilter = {};
	for (const key of filterFields.map((f) => f.key)) {
		const value = getValue(config, key);
		if (Array.isArray(value))
			(result as Record<string, unknown>)[key] = value.filter((v) => typeof v === "number" && v > 0);
	}
	for (const key of ["startDate", "endDate"] as const) {
		const value = getValue(config, key);
		if (typeof value === "string") result[key] = value.slice(0, 10);
	}
	return result;
}
